import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _Pixel;
import User from "./User";
import Model from "./Model";
export class Pixel extends Model {
  constructor(pixel) {
    super();
    _defineProperty(this, "Id", {
      fieldName: 'pixel_id',
      content: null
    });
    _defineProperty(this, "PixelUser", {
      fieldName: 'pixel_user',
      model: User,
      content: null
    });
    _defineProperty(this, "PixelType", {
      fieldName: 'pixel_type',
      content: null
    });
    _defineProperty(this, "PixelContent", {
      fieldName: 'pixel_code',
      content: null
    });
    _defineProperty(this, "PixelToken", {
      fieldName: 'pixel_token',
      content: null
    });
    if (pixel !== null && pixel !== void 0 && pixel.name) this.PixelType.content = pixel.name;
    if (pixel !== null && pixel !== void 0 && pixel.code) this.PixelContent.content = pixel.code;
  }
  static getPixelTypes() {
    return [Pixel.FACEBOOK, Pixel.SNAPCHAT, Pixel.TWITTER, Pixel.TIKTOK, Pixel.GOOGLE, Pixel.POSTBACK, Pixel.MICROSOFT_CLARITY, Pixel.GOOGLE_TAG];
  }
  static getPixelConversionOptions(type) {
    switch (type) {
      case this.FACEBOOK:
        return this.FACEBOOK_CONVERSION_OPTIONS;
      case this.TIKTOK:
        return this.TIKTOK_CONVERSION_OPTIONS;
      default:
        return [];
    }
  }
}
_Pixel = Pixel;
_defineProperty(Pixel, "FACEBOOK", 'facebook');
_defineProperty(Pixel, "SNAPCHAT", 'snapchat');
_defineProperty(Pixel, "TWITTER", 'twitter');
_defineProperty(Pixel, "TIKTOK", 'tiktok');
_defineProperty(Pixel, "GOOGLE", 'google');
_defineProperty(Pixel, "POSTBACK", 'postback');
_defineProperty(Pixel, "MICROSOFT_CLARITY", 'microsoft_clarity');
_defineProperty(Pixel, "GOOGLE_TAG", 'google_tag');
_defineProperty(Pixel, "CONVERSION_PURCHASE", 'Purchase');
_defineProperty(Pixel, "CONVERSION_LEAD", 'Lead');
_defineProperty(Pixel, "CONVERSION_COMPLETE_PAYMENT", 'CompletePayment');
_defineProperty(Pixel, "CONVERSION_PLACE_AN_ORDER", 'PlaceAnOrder');
_defineProperty(Pixel, "FACEBOOK_CONVERSION_OPTIONS", [_Pixel.CONVERSION_PURCHASE, _Pixel.CONVERSION_LEAD]);
_defineProperty(Pixel, "TIKTOK_CONVERSION_OPTIONS", [_Pixel.CONVERSION_COMPLETE_PAYMENT, _Pixel.CONVERSION_PLACE_AN_ORDER]);
export default Pixel;